import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import * as moment from 'moment';
import ProjectComment from 'src/entities/ProjectComment';
import { ApiProjectChildCommentResponse } from 'src/services/entity-factory/factories/ProjectChildCommentFactory';

export interface ApiProjectCommentResponse {
    id: number;
    body: string;
    authorId: number;
    authorName: string;
    projectId: number;
    createdAt: string;
    childComments: ApiProjectChildCommentResponse[];
}

interface ApiProjectCommentCreateRequest {
}

export class ProjectCommentFactory extends BaseFactory<ProjectComment> {
  public toEntity(args: ApiProjectCommentResponse): ProjectComment {
    return new ProjectComment({
      id: args.id,
      body: args.body,
      authorId: args.authorId,
      authorName: args.authorName,
      projectId: args.projectId,
      createdAt: moment(args.createdAt),
      childComments: args.childComments ?
        args.childComments.map(
        childComment => this.entityFactoryFactory.projectChildCommentFactory.toEntity(childComment)
        ) : [],
    });
  }

  public toRequest(projectComment: ProjectComment): ApiProjectCommentCreateRequest {
    return {
      body: projectComment.body,
      projectId: projectComment.projectId
    };
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/ProjectCommentFactory.tsx